module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    attrs: {
      "app": "",
      "absolute": "",
      "dark": ""
    }
  }, [_c('v-card', {
    staticClass: "flex"
  }, [_c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._v("\n      ©" + _vm._s(new Date().getFullYear()) + " — Superintendência de Tecnologia da Informação - UFES\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59fed644","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-layouts/footer.vue
// module id = 249
// module chunks = 0